"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RoundedButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireDefault(require("../styles/theme"));
var _gradient = _interopRequireDefault(require("../styles/gradient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var Span = _styledComponents["default"].span.withConfig({
  displayName: "Span",
  componentId: "sc-1uuz9g3-0"
})(["background:", ";align-items:center;border-radius:20px;padding-top:2%;padding-bottom:2%;display:flex;justify-content:center;height:100%;transition:background .5s ease;width:100%;:hover{background:transparent;}"], function (props) {
  return props.filledBackground ? 'transparent' : props.backgroundTheme;
});
Span.displayName = 'Span';
var Button = _styledComponents["default"].div.withConfig({
  displayName: "Button",
  componentId: "sc-1uuz9g3-1"
})(["background-image:", ";background-color:", ";border-radius:20px;box-sizing:border-box;color:black;display:-webkit-box;height:fit-content;margin:0 auto;padding:2px;position:relative;font-family:Raleway;font-style:normal;font-weight:500;line-height:30px;font-size:18px;text-transform:uppercase;text-decoration:none;cursor:", ";color:", ";width:", ";z-index:2;box-shadow:", ";:hover{color:", ";}"], function (props) {
  return props.theme;
}, function (props) {
  return props.theme;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.filledBackground ? _theme["default"].white : props.textTheme;
}, function (props) {
  return props.width;
}, function (props) {
  return props.shadow ? '0px 2px 4px rgba(0, 0, 0, 0.5)' : 'auto';
}, function (props) {
  return _theme["default"].white;
});
Button.displayName = 'Button';
var RoundedButton = /*#__PURE__*/function (_React$Component) {
  _inherits(RoundedButton, _React$Component);
  var _super = _createSuper(RoundedButton);
  function RoundedButton() {
    _classCallCheck(this, RoundedButton);
    return _super.apply(this, arguments);
  }
  _createClass(RoundedButton, [{
    key: "onButtonClick",
    value: function onButtonClick() {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick;
      if (!disabled) {
        onClick();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var selectedTheme = this.props.theme ? this.props.theme : _gradient["default"].berryGradient;
      var selectedTextTheme = this.props.textTheme ? this.props.textTheme : _theme["default"].darkTextDefault;
      var selectedBackgroundTheme = this.props.backgroundTheme ? this.props.backgroundTheme : _theme["default"].white;
      var width = this.props.width ? this.props.width : '200px';
      var _this$props2 = this.props,
        children = _this$props2.children,
        disabled = _this$props2.disabled,
        shadow = _this$props2.shadow,
        fill = _this$props2.fill,
        style = _this$props2.style,
        testID = _this$props2.testID;
      return /*#__PURE__*/_react["default"].createElement(Button, {
        filledBackground: fill,
        theme: selectedTheme,
        onClick: function onClick() {
          return _this.onButtonClick();
        },
        width: width,
        disabled: disabled,
        textTheme: selectedTextTheme,
        shadow: shadow,
        style: style,
        "data-cy": testID || 'RoundedButton'
      }, /*#__PURE__*/_react["default"].createElement(Span, {
        filledBackground: fill,
        backgroundTheme: selectedBackgroundTheme
      }, children));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return RoundedButton;
}(_react["default"].Component);
exports.RoundedButton = RoundedButton;
var _default = RoundedButton;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(Span, "Span", "/Users/crs/WebstormProjects/michelangelo/src/Components/Buttons/RoundedButton.js");
  reactHotLoader.register(Button, "Button", "/Users/crs/WebstormProjects/michelangelo/src/Components/Buttons/RoundedButton.js");
  reactHotLoader.register(RoundedButton, "RoundedButton", "/Users/crs/WebstormProjects/michelangelo/src/Components/Buttons/RoundedButton.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/Buttons/RoundedButton.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();